import { render, staticRenderFns } from "./Blackjack.vue?vue&type=template&id=8279d06e&scoped=true"
import script from "./Blackjack.vue?vue&type=script&lang=js"
export * from "./Blackjack.vue?vue&type=script&lang=js"
import style0 from "./Blackjack.vue?vue&type=style&index=0&id=8279d06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8279d06e",
  null
  
)

export default component.exports